import * as React from "react"

const LineS2 =  React.forwardRef((props, pathRef) => {
    return (

        <svg
            id={"line-s-2"}

            width={32}
            height={83}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 32 83`}

        >
            <path d="M0 1h16m0 0h16M16 1v82"

                  ref={pathRef}
                  stroke="#DEDDE2"

                  strokeWidth={2}
                  strokeDashoffset={props.normalizedPosition}
                  strokeDasharray={props.pathLength}

              />
        </svg>
    )
});
export default LineS2
